/// <reference path="../../../../Modules/Attr/Dialog/NoboxEntityDialog.ts" />
namespace Nobox.NoBoxCRM {

    @Serenity.Decorators.registerClass()
    export class FormSettingsDialog extends NoboxEntityDialog<any, any> {
        protected getFormKey() { return FormSettingsForm.formKey; }
        protected getIdProperty() { return FormRow.idProperty; }
        protected getLocalTextPrefix() { return FormRow.localTextPrefix; }
        protected getNameProperty() { return FormRow.nameProperty; }
        protected getService() { return FormService.baseUrl; }
        protected getDeletePermission() { return FormRow.deletePermission; }
        protected getInsertPermission() { return FormRow.insertPermission; }
        protected getUpdatePermission() { return FormRow.updatePermission; }

        protected form = new FormSettingsForm(this.idPrefix);
        protected inpIdElm = `<input type="text" class="editor IdOption" value="DataValue" placeholder="Value" style="max-width: 40px;text-align:center;">`;
        protected inpNmElm = `<input type="text" class="col NmOption ml-1" value="DataValue" placeholder="Text">`;
        protected btnDelete = `<a class="inplace-button deleteOption" title="Delete"><b><i class="fa fa-trash"></i></b></a>`;
        protected btnUp = `<a class="btn inplace-button upOption disabled" title="Move to top"><b><i class="fa fa-chevron-up"></i></b></a>`;
        protected btnDown = `<a class="btn inplace-button downOption disabled" title="Move to bottom"><b><i class="fa fa-chevron-down"></i></b></a>`;
        public data = [] as Array<selectOpsi>;
        protected valueDefValue = null;
        public callback = (res: settingsForm) => {

        }
        array_move(old_index, new_index) {
            if (new_index >= this.data.length) {
                var k = new_index - this.data.length + 1;
                while (k--) {
                    this.data.push(undefined);
                }
            }
            this.data.splice(new_index, 0, this.data.splice(old_index, 1)[0]);
            return this.data; // for testing
        };
        isValidJSON(jsonString) {
            try {
                JSON.parse(jsonString);
                return true;
            } catch (error) {
                return false;
            }
        }
        public configNew(selectOpsi: string) {
            //this.renderOptionElm(selectOpsi, "single");
            this.form.field.change(() => {
                let fld = this.form.field.value;
                if (fld == "input") {
                    this.form.inputType.getGridField().toggle(true);
                    this.form.selectOpsiElm.getGridField().toggle(false);
                    this.form.DefValue.getGridField().toggle(true);
                } else if (fld == "textarea") {
                    this.form.inputType.getGridField().toggle(false);
                    this.form.selectOpsiElm.getGridField().toggle(false);
                    this.form.DefValue.getGridField().toggle(true);
                } else if (fld == "select") {
                    this.form.inputType.getGridField().toggle(false);
                    this.form.selectOpsiElm.getGridField().toggle(true);
                    this.form.DefValue.getGridField().toggle(false);
                    this.renderOptionElm(selectOpsi, "single");
                }
            });
            this.form.inputType.change(() => {
                var val = this.form.inputType.get_value();
                let fld = this.form.field.value;
                if (fld === "input") {
                    if (val == "radio") {
                        this.form.selectOpsiElm.getGridField().toggle(true);
                        this.form.DefValue.getGridField().toggle(false);
                        this.renderOptionElm(selectOpsi, "single");
                    } else if (val == "checkbox") {
                        this.form.selectOpsiElm.getGridField().toggle(true);
                        this.form.DefValue.getGridField().toggle(false);
                        this.renderOptionElm(selectOpsi, "multi");
                    } else {
                        this.form.selectOpsiElm.getGridField().toggle(false);
                        this.form.DefValue.getGridField().toggle(true);
                        if (val == "file" && val == "fileMulti") {
                            this.form.DefValue.getGridField().toggle(false);
                        } else {
                            this.changeDefaultValueTypeField({ field: fld, inputType: val } as settingsForm)
                        }
                    }
                } else if (fld == "select" || fld == "select-multi") {
                    this.form.DefValue.getGridField().toggle(false);
                }
            })
        }
        public config = (res: form) => {
            if (res.id == 1 || res.id == 2 || res.id == 6 || res.id == 7 || res.id == 8 || res.id == 9) {
                this.form.field.getGridField().toggle(false);
                this.form.inputType.getGridField().toggle(false);
                this.form.selectOpsi.getGridField().toggle(false);
                this.form.required.getGridField().toggle(false);
                if (res.id == 6) {
                    let ctry = new Serenity.ServiceLookupEditor(this.form.DefValue.element, { idField: "Id", textField: "Name", service: "/Services/Master/Countries/List", pageSize: 19 } as Serenity.ServiceLookupEditorOptions)
                    ctry.change(() => {
                        let val = ctry.get_value();
                        if (!Q.isEmptyOrNull(val)) {
                            this.valueDefValue = JSON.stringify({ id: val, text: ctry.text })
                        } else {
                            this.valueDefValue = null;
                        }
                    })
                    if (!Q.isEmptyOrNull(res.settings.value) && this.isValidJSON(res.settings.value)) {
                        let objVal = JSON.parse(res.settings.value)
                        ctry.set_value(objVal.id);
                    }
                } else if (res.id == 7) {
                    let state = new Serenity.ServiceLookupEditor(this.form.DefValue.element, { idField: "Id", textField: "Name", service: "/Services/Master/States/List", pageSize: 19 } as Serenity.ServiceLookupEditorOptions)
                    state.change(() => {
                        let val = state.get_value();
                        if (!Q.isEmptyOrNull(val)) {
                            this.valueDefValue = JSON.stringify({ id: val, text: state.text })
                        } else {
                            this.valueDefValue = null;
                        }
                    })
                    if (!Q.isEmptyOrNull(res.settings.value) && this.isValidJSON(res.settings.value)) {
                        let objVal = JSON.parse(res.settings.value)
                        state.set_value(objVal.id);
                    }
                } else if (res.id == 8) {
                    let city = new Serenity.ServiceLookupEditor(this.form.DefValue.element, { idField: "Id", textField: "Name", service: "/Services/Master/Cities/List", pageSize: 19 } as Serenity.ServiceLookupEditorOptions)
                    city.change(() => {
                        let val = city.get_value();
                        if (!Q.isEmptyOrNull(val)) {
                            this.valueDefValue = JSON.stringify({ id: val, text: city.text })
                        } else {
                            this.valueDefValue = null;
                        }
                    })
                    if (!Q.isEmptyOrNull(res.settings.value) && this.isValidJSON(res.settings.value)) {
                        let objVal = JSON.parse(res.settings.value)
                        city.set_value(objVal.id);
                    }
                }
            } else if (res.id == 3 || res.id == 4 || res.id == 5) {
                this.form.field.getGridField().toggle(false);
                this.form.inputType.getGridField().toggle(false);
                this.form.selectOpsi.getGridField().toggle(false);
            } else {
                this.configNew(res.settings.selectOpsi == null ? null : JSON.stringify(res.settings.selectOpsi));
            }
        }

        renderOptionElm(datas, category) {
            if (Q.isEmptyOrNull(datas) || datas == "[]") {
                this.data = [{ id: '1', name: "Option 1", selected: false } as selectOpsi] as Array<selectOpsi>;
            } else {
                this.data = JSON.parse(datas) as Array<selectOpsi>;
            }

            this.form.selectOpsiElm.getGridField().toggle(true);
            this.form.DefValue.getGridField().toggle(false);
            this.form.selectOpsiElm.element.html("");
            var $this = this;
            if (this.data.length > 0) {
                this.data.forEach((yz, ind) => {
                    let elm = `<div class="field ${yz.id}" data-index="${ind}">`;
                    if (category == "single") {
                        elm += `<div class="custom-control custom-radio m-auto" style="right: -5px;"><input type="radio" id="radio-${yz.id}" value="${yz.id}" name="radioSetting" class="custom-control-input inpRadio" ind="${ind}" ${yz.selected ? "checked" : null}><label class="custom-control-label" for="radio-${yz.id}"></label></div>`
                    } else {
                        elm += `<div class="custom-control custom-checkbox m-auto" style="right: -5px;"><input type="checkbox" id="checkbox-${yz.id}" value="${yz.id}" name="checkboxSetting" class="custom-control-input inpCheckbox" ind="${ind}" ${yz.selected ? "checked" : null}><label class="custom-control-label" for="checkbox-${yz.id}"></label></div>`
                    }
                    elm += this.inpIdElm.replace("DataValue", `${yz.id}`);
                    elm += this.inpNmElm.replace("DataValue", `${yz.name}`);
                    if (this.data.length > 1)
                        elm += this.btnDelete;
                    if (ind != 0) {
                        elm += this.btnUp.replace("disabled", "");
                    } else {
                        elm += this.btnUp;
                    }

                    if (ind != this.data.length - 1) {
                        elm += this.btnDown.replace("disabled", "");
                    } else {
                        elm += this.btnDown;
                    }

                    elm += `</div>`
                    this.form.selectOpsiElm.element.append(elm);
                    $(".deleteOption").unbind("click");
                    $(".deleteOption").on("click", function () {
                        let i = $(this).parent().attr("data-index");
                        $this.data.splice(parseInt(i), 1);
                        $this.renderOptionElm(JSON.stringify($this.data), category)
                    });
                    $(".IdOption").unbind("keyup");
                    $(".IdOption").on("keyup", function () {
                        let i = $(this).parent().attr("data-index");
                        $this.data[i].id = $(this).val();
                    });
                    $(".NmOption").unbind("keyup");
                    $(".NmOption").on("keyup", function () {
                        let i = $(this).parent().attr("data-index");
                        $this.data[i].name = $(this).val();
                    });

                    $(".upOption").unbind("click");
                    $(".upOption").on("click", function () {
                        let i = $(this).parent().attr("data-index");
                        $this.array_move(i, parseInt(i) - 1);
                        $this.renderOptionElm(JSON.stringify($this.data), category);
                    });
                    $(".downOption").unbind("click");
                    $(".downOption").on("click", function () {
                        let i = $(this).parent().attr("data-index");
                        $this.array_move(i, parseInt(i) + 1);
                        $this.renderOptionElm(JSON.stringify($this.data), category);
                    });
                    $(".inpRadio").unbind("change");
                    $(".inpRadio").on("change", function () {
                        var jqElm = $(this);
                        let i = parseInt(jqElm.attr("ind"));
                        var val = jqElm.is(":checked");
                        $this.data.forEach((yz, indYz) => {
                            if (indYz == i) {
                                yz.selected = val;
                            } else {
                                yz.selected = false;
                            }
                        })
                    });
                    $(".inpCheckbox").unbind("change");
                    $(".inpCheckbox").on("change", function () {
                        var jqElm = $(this);
                        let i = jqElm.attr("ind");
                        $this.data[parseInt(i)].selected = jqElm.is(":checked");
                    });
                })
                var elmUnCheck = ""
                if (category == "single")
                    elmUnCheck = `<div class="btn btn-danger clearDefSelect mr-1">Clear Default Value</div>`;

                this.form.selectOpsiElm.element.append(`<div class="field Add" style="float: right;">${elmUnCheck}<div class="btn btn-primary addOptionSelect">Add Option</div></div>`);
                $(".addOptionSelect").unbind("click");
                $(".addOptionSelect").on("click", function () {
                    console.log($this.data.filter(x => Number(x.id) != NaN))
                    let maxObject = $this.data.filter(x => parseInt(x.id)).reduce(function (max, current) {
                        return (current.id > max.id) ? current : max;
                    }, $this.data[0]);
                    let jmlhData = (parseInt(maxObject.id) + 1).toString();

                    $this.data.push({ id: jmlhData, name: `Option ${jmlhData}`, selected: false })
                    $this.renderOptionElm(JSON.stringify($this.data), category);
                });

                $(".clearDefSelect").unbind("click");
                $(".clearDefSelect").on("click", function () {
                    $(`input[name="radioSetting"]`).prop("checked", false);
                    $this.data.forEach((yz) => {
                        yz.selected = false;
                    })
                });
            }
        }

        constructor() {
            super();
        }

        changeDefaultValueTypeField(entity: settingsForm) {
            this.form.DefValue.getGridField().toggle(true);
            if ($(".btnCustomDefValue"))
                $(".btnCustomDefValue").remove();

            if (entity.field == "input") {
                if (entity.inputType == "date" || entity.inputType == "time") {
                    $(`<a class="inplace-button btnCustomDefValue"><b><i class="fa ${entity.inputType == "date" ? "fa-calendar" : "fa-clock"} text-primary"></i></b></a>`)
                        .attr("title", "Set variable")
                        .insertAfter(this.form.DefValue.element)
                        .click(e => {
                            this.form.DefValue.value = entity.inputType == "date" ? "{CurrentDate}" : "{CurrentTime}";
                        })
                } else if (entity.inputType == "file" || entity.inputType == "fileMulti") {
                    this.form.DefValue.getGridField().toggle(false);
                }
            } else if (entity.field == "select" || entity.field == "select-multi") {
                this.form.DefValue.getGridField().toggle(false);
            }
        }

        hasDuplicateIds(array) {
            for (let i = 0; i < array.length - 1; i++) {
                for (let j = i + 1; j < array.length; j++) {
                    if (array[i].id === array[j].id) {
                        return true; // Found a duplicate ID
                    }
                }
            }
            return false; // No duplicate IDs found
        }

        loadEntity(entity: settingsForm) {
            super.loadEntity(entity);
            if (!Q.isEmptyOrNull(entity.orderQuantity) && entity.inputType == "order" && entity.field == "input") {
                var data = entity.orderQuantity.split(",");
                this.form.DefValue.getGridField().toggle(false);
                this.form.QDef.getGridField().toggle(true);
                this.form.QMin.getGridField().toggle(true);
                this.form.QMax.getGridField().toggle(true);
                this.form.QDef.value = parseInt(data[0]);
                this.form.QMin.value = parseInt(data[1]);
                this.form.QMax.value = parseInt(data[2]);
            } else {
                this.form.QDef.getGridField().toggle(false);
                if (!Q.isEmptyOrNull(entity.value))
                    this.form.DefValue.value = entity.value;

                this.changeDefaultValueTypeField(entity);
            }
        }

        onDialogOpen() {
            super.onDialogOpen();
            this.dialogTitle = "Custom Field";
        }

        getToolbarButtons() {
            return [];
        }

        getDialogButtons() {
            var btn = [] as Serenity.DialogButton[];
            var $form = this.form;
            btn.push({
                text: "Ok",
                hint: "Ok",
                click: () => {
                    if (this.validateForm()) {
                        console.log();
                        if (this.hasDuplicateIds(this.data)) {
                            Q.alert("Options has duplicate value")
                        } else {
                            this.callback({
                                field: $form.field.value,
                                label: $form.label.value,
                                inputType: Q.isEmptyOrNull($form.inputType.value) ? "order" : $form.inputType.value,
                                placeHolder: $form.placeHolder.value,
                                required: $form.required.value,
                                selectOpsi: this.data,
                                orderQuantity: [this.form.QDef.value, this.form.QMin.value, this.form.QMax.value].toString(),
                                value: Q.isEmptyOrNull(this.valueDefValue) ? this.form.DefValue.value : this.valueDefValue
                            });
                            this.dialogClose();
                        }
                    }
                }
            });
            btn.push({
                text: "Cancel",
                hint: "Cancel",
                click: () => {
                    this.dialogClose();
                }
            })
            return btn;
        }
    }
}
